import axios from 'axios';

const RESOURCE_NAME = '/messages';

export default {
    getCorrespondingCompanies(searchStr) {
        return axios.get(`${RESOURCE_NAME}/get-corresponding-companies?search=${searchStr}`)
    },

    getMessages(companyType, companyId, checkConnection, searchStr) {
        return axios.get(`${RESOURCE_NAME}/get-messages?company_type=${companyType}&company_id=${companyId}&check_connection=${checkConnection}&search=${searchStr}`)
    },

    checkNewMessages() {
        return axios.get(`${RESOURCE_NAME}/check-new-messages`)
    },

    sendMessage(companyType, companyId, message) {
        return axios.post(`${RESOURCE_NAME}/send-message?company_type=${companyType}&company_id=${companyId}`, {'message': message})
    },

    changeInvitationStatus(messageId, status) {
        return axios.post(`${RESOURCE_NAME}/change-invitation-status?message_id=${messageId}`, {'status': status})
    },
}